export * from './projekt-entfernt.interface';
